import { useState } from "react";
import { Button } from "./ui/button";
import InstructionsModal from "./InstructionsModal";
import { useNavigate } from "react-router-dom";

const Header = () => {
    const navigate = useNavigate();
    const [showInstructions, setShowInstructions] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const goToPage = (path) => {
        setMobileMenuOpen(false);
        navigate(path);
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "auto",
        });
    };

    const scrollToSection = (id) => {
        const el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
        setMobileMenuOpen(false);
    };

    const openInstructions = () => {
        setMobileMenuOpen(false);
        setShowInstructions(true);
    };

    const navButtonClass =
        "border-[3px] border-black bg-[#f7f3e8] px-4 py-2 text-sm font-black uppercase tracking-wide text-black shadow-[3px_3px_0_#000] transition hover:-translate-y-[1px] hover:bg-[#ffe78a]";

    const mobileNavButtonClass =
        "w-full border-[3px] border-black bg-[#f7f3e8] px-4 py-3 text-left text-sm font-black uppercase tracking-wide text-black shadow-[3px_3px_0_#000] transition hover:bg-[#ffe78a]";

    return (
        <>
            <header
                id="navbar"
                className="sticky top-0 z-50 w-full border-b-[4px] border-black bg-[#f2b400] px-4 py-3 shadow-[0_4px_0_#000] sm:px-6"
            >
                <div className="mx-auto flex max-w-7xl items-center justify-between gap-4">
                    {/* LEFT */}
                    <div
                        onClick={() => goToPage("/")}
                        className="cursor-pointer shrink-0 text-left text-xl leading-none sm:text-2xl lg:text-3xl"
                        style={{
                            fontFamily: "'Bangers', cursive",
                            color: "#fff7d6",
                            letterSpacing: "1px",
                            textShadow: `
                                -2px -2px 0 #000,
                                 2px -2px 0 #000,
                                -2px  2px 0 #000,
                                 2px  2px 0 #000,
                                 0px  2px 0 #000,
                                 2px  0px 0 #000,
                                -2px  0px 0 #000,
                                 0px -2px 0 #000
                            `,
                        }}
                    >
                        CALL IT OUT LOUD
                    </div>

                    {/* DESKTOP NAV */}
                    <nav className="hidden flex-1 items-center justify-center gap-3 lg:flex">
                        <button
                            type="button"
                            className={navButtonClass}
                            onClick={() => goToPage("/")}
                        >
                            Home
                        </button>
                        
                        <button
                            type="button"
                            className={navButtonClass}
                            onClick={() => goToPage("/schools")}
                        >
                            For Schools
                        </button>

                        {/* <button
                            type="button"
                            className={navButtonClass}
                            onClick={() => scrollToSection("categories")}
                        >
                            Categories
                        </button> */}


                        <button
                            type="button"
                            className={navButtonClass}
                            onClick={() => goToPage("/guides")}
                        >
                            Facilitator Guides
                        </button>

                        <button
                            type="button"
                            className={navButtonClass}
                            onClick={() => goToPage("/contact")}
                        >
                            Contact
                        </button>
                        
                        <button
                            type="button"
                            className={navButtonClass}
                            onClick={openInstructions}
                        >
                            Instructions
                        </button>
                    </nav>

                    {/* RIGHT */}
                    <div className="flex shrink-0 items-center gap-3">
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(true)}
                            className="flex h-11 w-11 items-center justify-center border-[3px] border-black bg-[#f7f3e8] text-black shadow-[3px_3px_0_#000] lg:hidden"
                            aria-label="Open menu"
                        >
                            <span className="flex flex-col gap-[4px]">
                                <span className="block h-[3px] w-5 bg-black" />
                                <span className="block h-[3px] w-5 bg-black" />
                                <span className="block h-[3px] w-5 bg-black" />
                            </span>
                        </button>

                        <Button
                            size="lg"
                            variant="play"
                            onClick={() => goToPage("/play")}
                            className="border-[3px] border-black bg-red-500 px-4 text-white shadow-[4px_4px_0_#000] transition hover:-translate-y-[1px] sm:px-6"
                            style={{
                                fontFamily: "'Bangers', cursive",
                                letterSpacing: "0.5px",
                            }}
                        >
                            Play Now! <span aria-hidden="true">→</span>
                        </Button>
                    </div>
                </div>
            </header>

            {/* MOBILE DRAWER */}
            {mobileMenuOpen && (
                <div className="fixed inset-0 z-[60] lg:hidden">
                    <button
                        type="button"
                        className="absolute inset-0 bg-black/55"
                        onClick={() => setMobileMenuOpen(false)}
                        aria-label="Close menu overlay"
                    />

                    <aside className="absolute right-0 top-0 flex h-full w-[88%] max-w-[360px] flex-col border-l-[4px] border-black bg-[#f2b400] p-5 shadow-[-6px_0_0_#000]">
                        <div className="mb-6 flex items-start justify-between gap-4">
                            <div
                                className="text-2xl leading-none"
                                style={{
                                    fontFamily: "'Bangers', cursive",
                                    color: "#fff7d6",
                                    letterSpacing: "1px",
                                    textShadow: `
                                        -2px -2px 0 #000,
                                         2px -2px 0 #000,
                                        -2px  2px 0 #000,
                                         2px  2px 0 #000,
                                         0px  2px 0 #000,
                                         2px  0px 0 #000,
                                        -2px  0px 0 #000,
                                         0px -2px 0 #000
                                    `,
                                }}
                            >
                                CALL IT OUT LOUD
                            </div>

                            <button
                                type="button"
                                onClick={() => setMobileMenuOpen(false)}
                                className="flex h-10 w-10 items-center justify-center border-[3px] border-black bg-[#f7f3e8] text-xl font-black text-black shadow-[3px_3px_0_#000]"
                                aria-label="Close menu"
                            >
                                ✕
                            </button>
                        </div>

                        <div className="flex flex-col gap-4">
                            <button
                                type="button"
                                className={mobileNavButtonClass}
                                onClick={() => goToPage("/")}
                            >
                                Home
                            </button>
                            
                            <button
                                type="button"
                                className={mobileNavButtonClass}
                                onClick={() => goToPage("/schools")}
                            >
                                For Schools
                            </button>


                            {/* <button
                                type="button"
                                className={mobileNavButtonClass}
                                onClick={() => scrollToSection("categories")}
                            >
                                Categories
                            </button> */}

                            <button
                                type="button"
                                className={mobileNavButtonClass}
                                onClick={() => goToPage("/guides")}
                            >
                                Facilitator Guides
                            </button>

                            <button
                                type="button"
                                className={mobileNavButtonClass}
                                onClick={() => goToPage("/contact")}
                            >
                                Contact
                            </button>

                            <button
                                type="button"
                                className={mobileNavButtonClass}
                                onClick={openInstructions}
                            >
                                Instructions
                            </button>

                        </div>

                        <div className="mt-6">
                            <Button
                                size="lg"
                                variant="play"
                                onClick={() => goToPage("/play")}
                                className="w-full border-[3px] border-black bg-red-500 text-white shadow-[4px_4px_0_#000]"
                                style={{
                                    fontFamily: "'Bangers', cursive",
                                    letterSpacing: "0.5px",
                                }}
                            >
                                Play Now! <span aria-hidden="true">→</span>
                            </Button>
                        </div>
                    </aside>
                </div>
            )}

            <InstructionsModal
                isOpen={showInstructions}
                onClose={() => setShowInstructions(false)}
            />
        </>
    );
};

export default Header;